module.exports = __webpack_public_path__ + "static/img/introduce_bottom3.e524ea93.png";